/* eslint-disable */

import { takeLatest, call, put } from "redux-saga/effects";
import { apiUrl } from "../components/Config/config";
import { GET_SETTING, SET_SETTING } from "../actions";
import cookie from "react-cookies";
import Axios from "axios";

export const watchGetSetting = function*() {
  yield takeLatest(GET_SETTING, workerGetSetting);
};

function* workerGetSetting() {
  const result = yield call(getSetting);
  yield put({ type: "SET_SETTING", json: result.data });
}

function getSetting() {
  const options = {
    headers: { Auth: cookie.load("user_details").token }
  };
  return Axios.get(apiUrl + "pages/settings", options).then(
    response => {
      return response;
    },
    error => {
      return { data: { status: error.response.data.status } };
    }
  );
}

